import React from 'react'

const Admin_user_profile = () => {
  return <div>Admin_user_profile</div>
}

export default Admin_user_profile
